export const language: any = {
  title: "हे! कूकर समुदाय",
  follow: "फॉलो करें",
  follower: "अनुयायी",
  post_share: "साझा की गई पोस्ट",
  like_share: "पसंद",
  report: "उल्लंघन की रिपोर्ट करें",
  delete_post: "पोस्ट हटाएं",
  delete_comment: "टिप्पणी हटाएं",
  confirm_report: "क्या आपको यकीन है कि यह पोस्ट सामुदायिक दिशानिर्देशों का उल्लंघन करती है? यदि रिपोर्ट सफल होती है, तो आप इस पोस्ट को नहीं देख पाएंगे।",
  confirm_report_comment: "क्या आपको यकीन है कि यह टिप्पणी सामुदायिक दिशानिर्देशों का उल्लंघन करती है?",
  toats_report: "रिपोर्ट करने के लिए धन्यवाद। आपकी रिपोर्ट की समीक्षा की जा रही है।",
  confirm_delete: "क्या आप वाकई इस पोस्ट को हटाना चाहते हैं?",
  confirm_delete_comment: "क्या आप वाकई इस टिप्पणी को हटाना चाहते हैं?",
  toast_delete: "सफलतापूर्वक हटाया गया!",
  text_yes: "हाँ",
  text_no: "नहीं",
  create: {
    title: "पोस्ट बनाएं - हे! कूकर समुदाय",
    content_placeholder: "पोस्ट सामग्री दर्ज करें",
    submit: "अभी साझा करें",
    add_image_by_camera: "कैमरा से फोटो लें",
    add_image_by_gallery: "गैलरी से फोटो चुनें",
    add_video_by_camera: "कैमरा से वीडियो लें",
    add_video_by_gallery: "गैलरी से वीडियो चुनें"
  },
  detail: {
    shared: "साझा किया गया",
    shared_community: "फोटो (वीडियो) समुदाय के साथ साझा किया गया"
  },
  follwed: "अनुसरण किया",
  comment: {
    placeholder: "कृपया अपनी टिप्पणी दर्ज करें",
    submit: "भेजें",
    nodata: "यहां टिप्पणी करें और पहले टिप्पणीकार बनें!",
    load_more: "और टिप्पणियाँ देखें",
    not_login: "टिप्पणी करने के लिए कृपया लॉग इन करें",
    delete: "टिप्पणी हटाएँ",
    delete_confirm: "क्या आप वाकई इस टिप्पणी को हटाना चाहते हैं?",
    delete_success: "टिप्पणी सफलतापूर्वक हटा दी गई",
    report: "रिपोर्ट करें",
    report_confirm: "क्या आप सुनिश्चित हैं कि यह टिप्पणी सामुदायिक दिशानिर्देशों का उल्लंघन करती है?",
    report_success: "रिपोर्ट करने के लिए धन्यवाद,\nआपकी रिपोर्ट की समीक्षा की जा रही है",
  },
  bottom_navigation: "समुदाय",
  shared_post: "पोस्ट साझा किया गया"
};
